
export const binArray: string[] = [ 
  '400229',
  '400344',
  '403065',
  '403200',
  '403201',
  '403202',
  '403299',
  '403444',
  '403694',
  '404614',
  '404615',
  '406096',
  '410608',
  '410673',
  '411358',
  '411507',
  '412128',
  '412174',
  '412179',
  '413028',
  '413113',
  '413140',
  '413160',
  '413165',
  '413170',
  '413716',
  '414709',
  '415417',
  '415557',
  '416841',
  '419310',
  '420042',
  '420043',
  '421759',
  '421794',
  '422983',
  '423311',
  '423340',
  '424642',
  '424642',
  '424735',
  '425418',
  '426930',
  '426932',
  '426933',
  '426934',
  '426944',
  '426993',
  '426994',
  '426996',
  '427501',
  '427502',
  '427546',
  '429137',
  '429184',
  '429185',
  '430200',
  '430572',
  '431047',
  '431467',
  '431468',
  '431663',
  '431689',
  '431734',
  '438826',
  '438845',
  '438856',
  '438864',
  '440560',
  '440561',
  '443122',
  '443508',
  '449867',
  '449882',
  '463099',
  '463814',
  '464444',
  '465602',
  '466303',
  '466304',
  '466306',
  '466307',
  '466309',
  '466800',
  '468405',
  '468406',
  '471206',
  '473068',
  '473344',
  '474672',
  '474673',
  '474743',
  '475086',
  '475698',
  '477767',
  '478827',
  '478828',
  '479124',
  '479365',
  '480213',
  '480385',
  '486236',
  '487333',
  '487334',
  '493109',
  '493109',
  '493422',
  '511379',
  '511912',
  '512025',
  '512026',
  '512027',
  '512300',
  '512731',
  '512734',
  '514953',
  '515592',
  '515593',
  '515596',
  '515597',
  '515598',
  '515599',
  '515600',
  '515676',
  '517669',
  '517805',
  '517993',
  '517997',
  '517998',
  '518374',
  '518725',
  '518726',
  '520094',
  '520101',
  '520103',
  '520104',
  '520105',
  '520106',
  '520118',
  '520611',
  '520612',
  '521331',
  '521506',
  '522233',
  '522955',
  '524324',
  '525999',
  '526444',
  '528211',
  '528942',
  '529107',
  '529115',
  '529123',
  '529149',
  '529156',
  '529172',
  '531480',
  '531651',
  '532830',
  '532839',
  '539858',
  '540159',
  '540419',
  '540420',
  '540421',
  '540422',
  '540423',
  '540424',
  '540426',
  '540633',
  '540704',
  '540791',
  '540801',
  '541058',
  '541336',
  '541444',
  '541448',
  '541449',
  '541474',
  '541513',
  '541536',
  '541549',
  '541578',
  '541586',
  '541627',
  '541829',
  '542442',
  '542583',
  '542775',
  '543328',
  '543339',
  '543368',
  '543857',
  '543961',
  '544045',
  '544316',
  '544317',
  '544347',
  '544516',
  '544910',
  '545800',
  '546281',
  '546283',
  '546608',
  '546630',
  '546720',
  '547855',
  '548885',
  '548892',
  '548897',
  '548950',
  '548951',
  '548955',
  '549062',
  '549066',
  '549107',
  '549110',
  '549111',
  '549112',
  '549120',
  '549121',
  '549506',
  '550300',
  '552436',
  '552851',
  '552869',
  '554356',
  '557867',
  '558663',
  '558958',
  // dummy bin info added
  '555555',
  '222300',
  '411111',
  '400551',
  '400934',
  '401200',
  '401288',
  '421765',
  '450060',
  '403000',
];


export const dummyLastFour:string[] = [
  '4444',
  '0011',
  '1111',
  '0004',
  '1881',
  '7777',
  '1881',
  '1119',
  '0061',
  '0026',
];